export const TRANSFER_PATH = '/transfer'

/**
 * Query param of the transfer link (`/transfer?transferToken=<token>`), built by wallbox-api.
 * It must not be `token`: `@wallbox/http` reads that param on every `getToken()` and stores it
 * as the session token.
 */
export const TRANSFER_TOKEN_QUERY = 'transferToken'
